/**
 * Created by danielr on 6/16/15.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseCollection = require("collections/BaseCollection");
    var DateUtility = require("utils/DateUtility");
    var AppKeyGalleryModel = require("manager-models/data-sources/integrations/app-keys/AppKeyGalleryModel");

    var NAME = "AppKeysGalleryCollection";

    var AppKeysGalleryCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AppKeysGalleryCollection = BaseCollection.extend({
            model: AppKeyGalleryModel,
            name: NAME,
            comparator: function(model) {
                var createdDate = model.getDateCreated();
                return DateUtility.strToDateObj(createdDate).getTime();
            },
            getModelByApplicationKey: function(applicationKey){
                var result = _.find(this.models, function(model){
                    return model.getAppKey() === applicationKey;
                });
                return result;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    AppKeysGalleryCollection.NAME = NAME;

    return AppKeysGalleryCollection;
});
